exports = module.exports = require("../../../../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.receipt-dialog .receipt-box[data-v-7ed2f472] {\n  min-height: 159px;\n}\n.receipt-dialog .receipt-box .img-wrapper .img-div[data-v-7ed2f472] {\n    width: 100%;\n    height: 100%;\n}\n.receipt-dialog .receipt-box .img-wrapper .img-div .el-upload-list__item-thumbnail[data-v-7ed2f472] {\n      -o-object-fit: cover;\n         object-fit: cover;\n}\n.receipt-dialog .receipt-box .img-wrapper .img-div .el-upload-list__item-preview i[data-v-7ed2f472] {\n      color: #fff;\n}\n.receipt-dialog .receipt-box .empty-wrapper[data-v-7ed2f472] {\n    height: 159px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ed2f472","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/views/personal/order/detail/components/receiptDialog/index.vue
// module id = /cLA
// module chunks = 1